import { Link } from 'gatsby';
import React from 'react'
import { slide as Menu } from 'react-burger-menu'
import { PRODUCTS_PAGE, SUPPORT_PAGE } from '../constant/routes';
import { FooterItems } from './FooterComponent';

import {MenuStyles} from "./MenuStyle"
import ResourcesDropdown from './ResourcesDropdown';




const MobileNav = () => {
    const [showResourcesMenu, setShowResourcesMenu] = React.useState(false);
    const [setShowProductMenu] = React.useState(false);
  return (
    <>
    <Menu styles={MenuStyles} right>
        <div>
        <img
               className="logo"
                src="https://res.cloudinary.com/webbermill/image/upload/v1679656994/webbermill-website-assets/static/banner/footer-logo_rksy4p.svg"
                alt="logo"
                width={150}
              />
        </div>
        <div className='menu_list'>
        <Link to={PRODUCTS_PAGE} id="home" className="menu-item" href="/">PRODUCTS</Link>
        <Link to={SUPPORT_PAGE} id="about" className="menu-item" href="/about">SUPPORT</Link>
        {/* <a id="contact" className="menu-item" onClick={() => setShowResourcesMenu((prev) => !prev)}>RESOURCES  <span>
                  {showResourcesMenu ? <BiChevronUp fontSize={30}/> : <BiChevronDown fontSize={30}/>}
                </span></a>
                {
                showResourcesMenu && (
                <ResourcesList setShowResourcesMenu={setShowResourcesMenu}/>
                )
               } */}
               <ResourcesDropdown showResourcesMenu={showResourcesMenu} setShowResourcesMenu={setShowResourcesMenu} setShowProductMenu={setShowProductMenu}/>
        </div>
        <div className='mobile-footer'>
        <img
               className=""
                src="https://res.cloudinary.com/webbermill/image/upload/v1679656994/webbermill-website-assets/static/banner/footer-logo_rksy4p.svg"
                alt="logo"
                width={150}
              />
         <div>
         <ul>
              {FooterItems.map((item) => (
                <li key={item.id}>
                  <Link to={item.path}>{item.name}</Link>
                </li>
              ))}
            </ul>
         </div>
        </div>
      </Menu>
    </>
  )
}

export default MobileNav